import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import StartHere from "@/pages/StartHere";
import Ideas from "@/pages/Ideas";
import ArticleDetail from "@/pages/ArticleDetail";
import Principles from "@/pages/Principles";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import Resources from "@/pages/Resources";
import Programs from "@/pages/Programs";
import About from "@/pages/About";
import Join from "@/pages/Join";
import Contact from "@/pages/Contact";
import LandingPage from "@/pages/LandingPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Privacy, Terms } from "@/pages/Legal";
import AdminApp from "@/admin/AdminApp";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start-here" element={<StartHere />} />
          <Route path="/ideas" element={<Ideas />} />
          <Route path="/ideas/article/:slug" element={<ArticleDetail />} />
          <Route path="/ideas/:category" element={<Ideas />} />
          <Route path="/principles" element={<Principles />} />
          <Route path="/books" element={<Books />} />
          <Route path="/books/:slug" element={<BookDetail />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/about" element={<About />} />
          <Route path="/join" element={<Join />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/lp/:slug" element={<LandingPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
